import { render, staticRenderFns } from "./TollFee.vue?vue&type=template&id=14c5962a&scoped=true"
import script from "./TollFee.vue?vue&type=script&lang=js"
export * from "./TollFee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c5962a",
  null
  
)

export default component.exports